import _ExpandMore from "@material-ui/icons/esm/ExpandMore";
import React from 'react';
import cs from 'classnames';
import { CSSTransition } from 'react-transition-group';
import classes from './notecard-editor-select-wrapper.scss';
export const NotecardEditorSelectWrapper = ({
  isOpened,
  isDisabled,
  children,
  name,
  icon,
  animationClasses,
  toggleOpened
}) => {
  return /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: animationClasses,
    in: isOpened,
    timeout: 500
  }, /*#__PURE__*/React.createElement("div", {
    className: cs(classes.toolbarItem, {
      [classes.toolbarItemExpanded]: isOpened
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cs(classes.toolbarItemMainColumn, {
      [classes.toolbarItemDisabled]: isDisabled
    })
  }, /*#__PURE__*/React.createElement("div", {
    onClick: toggleOpened,
    className: classes.toolbarItemHead
  }, icon, /*#__PURE__*/React.createElement("div", {
    className: classes.toolbarItemHeadText
  }, name), /*#__PURE__*/React.createElement("div", {
    className: cs(classes.toolbarItemExpandIcon, {
      [classes.toolbarItemExpandIconReverse]: isOpened
    })
  }, /*#__PURE__*/React.createElement(_ExpandMore, null))), /*#__PURE__*/React.createElement("div", {
    className: classes.toolbarItemBody,
    "data-block": "DesignNote"
  }, children))));
};